<template>
    <div class="login-signup-section" style="z-index: 8;">
        <div class="header-logo">
            <router-link :to="{ path: 'apps' }">
                <img src="/assets/img/logo.svg" alt="" width="232">
            </router-link>
        </div>
        <div class="login-left-part d-md-flex align-items-center">
            <div class="form-part" v-if="!confirmed">
                <h1>Set password</h1>
                <ValidationObserver ref="form" v-slot="{ invalid }">
                    <b-form v-on:submit.prevent="changePassword()"
                            class="">
                        <div horizontal class="form-group">
                            <ValidationProvider
                                name="Password"
                                rules="required|min:8"
                                v-slot="{ errors }"
                                vid="password">
                                <b-form-input id="password"
                                              type="password"
                                              class="form-control"
                                              placeholder="Password"
                                              v-model="form.password"
                                              ref="password"/>

                                <div class="field-check" v-if="form.password && errors.length < 1"></div>
                                <template v-if="errors.length > 0">
                                    <b-form-row class="text-danger">
                                        <i class="fa fa-warning"></i>
                                        <span class="help invalid-feedback">
                                    {{ errors[0]}}
                                </span>
                                    </b-form-row>
                                </template>

                            </ValidationProvider>
                        </div>
                        <div horizontal class="form-group">
                            <ValidationProvider
                                name="Password Confirmation"
                                rules="confirmed:password"
                                v-slot="{ errors }"
                                vid="password_confirmation">
                                <b-form-input id="confirmPassword"
                                              name="password_confirmation"
                                              class="form-control"
                                              placeholder="Confirm your password"
                                              type="password"
                                              v-model="form.password_confirmation"/>
                                <div class="field-check" v-if="form.password_confirmation && errors.length < 1"></div>
                                <template v-if="errors.length > 0">
                                    <b-form-row class="text-danger">
                                        <i class="fa fa-warning"></i>
                                        <span class="help invalid-feedback" v-if="errors[0]">
                                    Passwords are not matched
                                </span>
                                    </b-form-row>
                                </template>

                            </ValidationProvider>
                        </div>
                        <div class="invalid-feedback" v-for="error in errors" :key="error">
                            {{ error }}
                        </div>
                        <div class="form-group form-btn">
                            <b-button :disabled="invalid"
                                      type="submit"
                                      variant="primary">Submit</b-button>
                        </div>

                    </b-form>
                </ValidationObserver>
            </div>
            <div class="thanks-signing"  v-else>
                <p>{{  successMessage }}</p>

                <div class="thanks-check mb-3">
                    <img src="/assets/img/check-icon-big.svg" alt="">
                </div>
                <router-link :to="{ path: '/login'}" class="btn btn-outline-primary">Sign in</router-link>

            </div>

        </div>
        <div class="login-right-part">
            <div class="login-right-logo">
                <img src="/assets/img/right-logo.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {ValidationObserver, ValidationProvider} from "vee-validate";
import ApiService from "../api/api.service";
export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            errorMessage: "",
            successMessage: "",
            text: "success",
            errors: [],
            form: {
                password: '',
                password_confirmation: '',
                token: this.$route.query.token,
                email: this.$route.query.email,
            },
            confirmed: false,
        }
    },
    name: "PasswordReset",
    methods: {
        changePassword() {
            ApiService.post('/api/password/reset', this.form)
            .then(({data}) => {
                this.successMessage = data.data;
                this.confirmed = true;
            })
            .catch(error  => {
                console.log(error.response.data.data);
                this.errors = [error.response.data.data];
                // this.errorMessage = error.response.data;
            });
        },

    }
}
</script>

<style scoped>

</style>
